/* Ayudate · Buscador de cursos con sugerencias */

import React, { useState } from "react";
import { infoCurso } from "../datos/areas";
import { buscarCursos } from "../lib/buscar";
import { norm } from "../lib/formato";
import { vCurso } from "../lib/validar";
import { Ayuda } from "./Mensajes";

export function BuscadorCursos({ elegidos, onChange, areas = null, ph, marcar = false, deshabilitado = false }) {
  const [q, setQ] = useState("");
  const [foco, setFoco] = useState(-1);
  const sugerencias = deshabilitado ? [] : buscarCursos(q, elegidos, areas);
  const limpio = q.trim();
  const errorCurso = vCurso(q);
  const propio = !deshabilitado && limpio.length >= 3 && sugerencias.length === 0 && !errorCurso
    && !elegidos.some((c) => norm(c) === norm(limpio));
  const abierto = sugerencias.length > 0 || propio;

  const agregar = (cod) => {
    onChange([...elegidos, cod]);
    setQ(""); setFoco(-1);
  };
  const quitar = (cod) => onChange(elegidos.filter((c) => c !== cod));

  const teclas = (e) => {
    if (!abierto) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setFoco((f) => (f + 1) % sugerencias.length); }
    if (e.key === "ArrowUp") { e.preventDefault(); setFoco((f) => (f - 1 + sugerencias.length) % sugerencias.length); }
    if (e.key === "Enter") {
      e.preventDefault();
      if (sugerencias.length === 0 && !errorCurso) agregar(limpio);
      else agregar(sugerencias[foco >= 0 ? foco : 0].cod);
    }
    if (e.key === "Escape") setQ("");
  };

  return (
    <div className="bc">
      <input id="curso-buscador" className={`in ${marcar || errorCurso ? "falta" : ""}`} value={q}
        disabled={deshabilitado}
        onChange={(e) => { setQ(e.target.value); setFoco(-1); }}
        onKeyDown={teclas} autoComplete="off"
        placeholder={deshabilitado ? "Elija primero una categoría arriba" : (ph || "Escriba el nombre o el código. Ej: mate, cálculo, FI1101")}
        aria-label="Buscar cursos por nombre o código"
        aria-expanded={abierto} aria-autocomplete="list" role="combobox" />
      {errorCurso && <Ayuda texto="" error={errorCurso} mostrar />}

      {abierto && (
        <ul className="bcsug" role="listbox" aria-label="Cursos sugeridos">
          {sugerencias.map((c, i) => (
            <li key={c.cod}>
              <button type="button" role="option" aria-selected={i === foco}
                className={`bcop ${i === foco ? "on" : ""}`}
                onMouseEnter={() => setFoco(i)} onClick={() => agregar(c.cod)}>
                {!c.sinCodigo && (
                  <span className="bccod" style={{ "--ac": c.color }}>{c.cod}</span>
                )}
                <span className="bcnom">{c.nom}<i>{c.instNom ? `${c.instNom} · ${c.areaNom}` : c.areaNom}</i></span>
              </button>
            </li>
          ))}
          {propio && (
            <li>
              <button type="button" role="option" aria-selected={false}
                className="bcop bcotro" onClick={() => agregar(limpio)}>
                <span className="bcmas" aria-hidden="true">+</span>
                <span className="bcnom">{limpio}</span>
              </button>
            </li>
          )}
        </ul>
      )}

      {elegidos.length > 0 && (
        <div className="bcsel">
          {elegidos.map((cod) => {
            const c = infoCurso(cod);
            return (
              <span className="bcchip" key={cod} style={{ "--ac": c.color }}>
                {!c.sinCodigo && <b>{c.cod}</b>} {c.nom}
                <button type="button" onClick={() => quitar(cod)}
                  aria-label={`Quitar ${c.nom}`}>×</button>
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
}
